module.exports = __webpack_public_path__ + "static/WelcomeToElk5-7804c8f88307e87a006557504405624b.png";